import { useEffect, useState } from "react";
import { DividerLine } from "../common/DividerLine"
import { ListingCard } from "./ListingCard"
import { ListingCardSkeleton } from "../skeletons/ListingCardSkeleton";
import { getProductsList } from "../../api/requests/product";
import { PorductSearchFilters, ProductFilterContainerFilters, ProductListResponse } from "../../api/requests/interfaces/Product";
import { DEFAULT_PRODUCTS_PAGE, DEFAULT_PRODUCTS_TAKE, removeAllFilters, setFiltersInitialized, updateFilterValues, useHandleSearch } from '../../store/features/searchSlice';

import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { useLocation } from "react-router-dom";
import { Pagination } from "@mui/material";
import { ProductCategory } from "../../constants/products";
import AdvertisementSlider from "../adverts/AdvertisementSlider";
import { getAdvertsPublic } from "../../api/requests/advert";
import { AdvertPublicListModel } from "../../api/requests/interfaces/Advert";

export const ListingListView = () => {

    const [dataLoading, setDataLoading] = useState(true);
    const [productsList, setProductsList] = useState<ProductListResponse[]>([]);
    const [adverts, setAdverts] = useState<AdvertPublicListModel[]>([]);
    const filters = useAppSelector((s) => s.search.filters);
    const filtersInitialized = useAppSelector((s) => s.search.filtersInitialized);
    const searchFromFilterBtnVal = useAppSelector((s) => s.search.searchFromFilterBtn);
    const [productsCount, setProductsCount] = useState(0);
    const [page, setPage] = useState(1);
    const [take, setTake] = useState(0);
    const [skip, setSkip] = useState(0);

    const location = useLocation();
    const { handleSearch } = useHandleSearch();

    const dispatch = useAppDispatch();

    useEffect(() => {
        getMainPageAdverts();
        if (location.pathname !== "/search") {
            dispatch(setFiltersInitialized())
            dispatch(removeAllFilters());
            getProducts("none");
            return;
        }
        window.scrollTo(0, 0);
        const filtersFromUrl = parseFiltersFromUrl(location.search);
        handleSearch(filtersFromUrl, searchFromFilterBtnVal);
        // getProducts("params", filtersFromUrl);
    }, [])

    useEffect(() => {
        if (location.pathname === "/search") {
            const filtersFromUrl = parseFiltersFromUrl(location.search);
            handleSearch(filtersFromUrl, searchFromFilterBtnVal);
            // getProducts("params", filtersFromUrl);
        }
    }, [location.search])

    useEffect(() => {
        window.scrollTo(0, 0);
        // if (filtersInitialized) {
        //     getProducts("global");
        //     setPage(filters.page + 1);
        // }
        getProducts("global");
        setPage(filters.page + 1);
    }, [filters])

    useEffect(() => {
        console.log('location ', location.pathname);
        if (location.pathname === "/") {
            dispatch(removeAllFilters());
            getProducts("none");
        }
    }, [location.pathname])

    const getMainPageAdverts = async () => {
        const res = await getAdvertsPublic();
        setAdverts(res);
    }

    const getProducts = async (useFilters: string, filtersData?: PorductSearchFilters) => {
        setDataLoading(true);
        filtersData && console.log(JSON.stringify(filtersData))
        const res = await getProductsList(useFilters === "global" ? {
            take: filters.take, skip: filters.page * filters.take, category: filters.category, startDate: filters.startDate,
            endDate: filters.endDate, startTime: filters.startTime, endTime: filters.endTime, title: filters.title, location: filters.location,
            isOneDayRental: filters.isOneDayRental, oneDayRentalDate: filters.oneDayRentalDate
        } : useFilters === "none" ? {take: DEFAULT_PRODUCTS_TAKE, skip: DEFAULT_PRODUCTS_TAKE * DEFAULT_PRODUCTS_PAGE} : filtersData!);
        setProductsList([...res.data])
        setProductsCount(res.total);
        setDataLoading(false);
    }

    const parseFiltersFromUrl = (urlSearch: string): ProductFilterContainerFilters => {
        const params = new URLSearchParams(urlSearch);
        const skipPage = params.get("page") ? Number(params.get("page")) : DEFAULT_PRODUCTS_PAGE;
        const takeProducts = params.get("take") ? Number(params.get("take")) : DEFAULT_PRODUCTS_TAKE;
        setPage(skipPage + 1);

        return {
            page: skipPage,
            take: takeProducts, // Default value for take
            category: params.get("category") as ProductCategory || undefined,
            startDate: params.get("startDate") ? new Date(params.get("startDate")!) : undefined, // Parse date if exists
            endDate: params.get("endDate") ? new Date(params.get("endDate")!) : undefined, // Parse date if exists
            startTime: params.get("startTime") || undefined,
            endTime: params.get("endTime") || undefined,
            title: params.get("title") || undefined,
            location: params.get("location") || undefined,
            isOneDayRental: params.get("isOneDayRental") ? Boolean(params.get("isOneDayRental")) : undefined,
            oneDayRentalDate: params.get("oneDayRentalDate") ? new Date(params.get("oneDayRentalDate")!) : undefined,
        };
    };

    const handlePageChange = (page: number) => {
        handleSearch({...filters, page: page - 1 }, searchFromFilterBtnVal, true);
        setPage(page);
    }

    return (
        <div className="flex flex-col gap-6 text-left">
            {filters.title &&
                <h3 className="text-gray-600 font-semibold text-[18px]">
                    Otsingutulemused: "{filters.title}"
                </h3>
            }
            {/* <h2>
                Esile tõstetud
            </h2> */}
            {/* <DividerLine />  */}
            <div className={`grid lg:grid-cols-2 ${dataLoading ? "gap-10" : "gap-4"} mb-[100px] md:mb-0`}>
                {
                    dataLoading ?
                        [...Array(8)].map(() => (
                            <ListingCardSkeleton />
                        ))
                        :
                        <>
                            {productsList.length ?
                                productsList.map(itm =>
                                    <ListingCard data={itm} />
                                )
                                :
                                <div className="text-primary font-medium">
                                    Tulemusi ei leitud! :(
                                </div>
                            }
                        </>
                }
            </div>
            {productsList.length ?
            <div className="flex justify-center mt-4">
                <Pagination count={Math.floor(productsCount / filters.take)} page={page}
                            onChange={(e, p) => handlePageChange(p)}/>
            </div>
            :
            <></>}
            {
                adverts.length &&
                <div className="fixed bottom-0 left-0 w-full h-[70px] z-50">
                    <AdvertisementSlider images={adverts.map((itm) => {
                        return {img: itm.picUrl, link: itm.linkUrl}})}/>
                </div>
            }
        </div>
    )
}